import { queryOptions, useQuery } from '@tanstack/react-query';

import { sharedApi } from '../../apis/shared.api';


interface CampaignQueryOptions {
  enabled?: boolean;
  campaignId: number; // Add campaignId to the interface
}

export function campaignQueryOptions(params: CampaignQueryOptions) {
  return queryOptions({
    queryKey: ['campaign', params.campaignId], // Include campaignId in the queryKey
    queryFn: () => sharedApi.campaign(params.campaignId), // Call sharedApi.campaign with the ID
    enabled: params.enabled,
  });
}
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface UseCampaign {}

export function useCampaign(campaignId: number, options: { enabled?: boolean } = {}) {
  const query = useQuery(    
    campaignQueryOptions({
      campaignId,
      enabled: options.enabled,
    }));

  return query;
}

export default useCampaign;
